<template>
<div class="mt-root" :style="themePageStyle">
  <nav class="mt-topbar"><div class="container d-flex align-items-center justify-content-between py-2">
    <div class="d-flex align-items-center" style="gap:12px;">
      <a href="javascript:void(0)" @click="$router.go(-1)" class="mt-back"><i class="mdi mdi-arrow-left"></i></a>
      <img src="assets/images/flockr_logo.png" alt="Flockr" style="height:32px;" />
      <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:14px;">My Transport Bookings</span>
    </div>
    <button class="btn btn-sm btn-warning" @click="$router.push('/transport')"><i class="mdi mdi-plus me-1"></i>Book Transport</button>
  </div></nav>

  <div class="container mt-container">
    <!-- Filter bar -->
    <div class="d-flex gap-2 mb-3 flex-wrap">
      <button class="mt-chip" :class="{active:filter===''}" @click="filter=''">All <span class="mt-chip-count">{{ bookings.length }}</span></button>
      <button class="mt-chip" :class="{active:filter==='pending'}" @click="filter='pending'">Pending <span class="mt-chip-count">{{ countByGroup('pending') }}</span></button>
      <button class="mt-chip" :class="{active:filter==='active'}" @click="filter='active'">Active <span class="mt-chip-count">{{ countByGroup('active') }}</span></button>
      <button class="mt-chip" :class="{active:filter==='completed'}" @click="filter='completed'">Completed <span class="mt-chip-count">{{ countByGroup('completed') }}</span></button>
      <button class="mt-chip" :class="{active:filter==='cancelled'}" @click="filter='cancelled'">Cancelled <span class="mt-chip-count">{{ countByGroup('cancelled') }}</span></button>
    </div>

    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

    <div v-else-if="!filtered.length" class="text-center py-5">
      <i class="mdi mdi-truck-outline" style="font-size:64px;color:var(--fm-s,#3A3530);"></i>
      <h5 class="mt-3" style="color:var(--fm-h,#F5F0E8);">{{ bookings.length ? 'No bookings in this view' : 'No transport bookings yet' }}</h5>
      <p v-if="!bookings.length" style="color:var(--fm-s,#6B6356);">When you request transport, your bookings will show up here so you can track their progress.</p>
      <button v-if="!bookings.length" class="btn btn-warning mt-2" @click="$router.push('/transport')"><i class="mdi mdi-magnify me-1"></i>Find a Transporter</button>
    </div>

    <div v-else>
      <div v-for="b in filtered" :key="b.id" class="mt-card mb-2" @click="$router.push('/transport/trip/'+b.id)" style="cursor:pointer;">
        <div class="d-flex align-items-start gap-3">
          <div class="mt-icon" :class="'ic-'+statusGroup(b.status)">
            <i class="mdi" :class="statusIcon(b.status)"></i>
          </div>
          <div class="flex-fill" style="min-width:0;">
            <div style="color:var(--fm-h,#F5F0E8);font-weight:600;font-size:14px;">
              {{ b.transporter_name || 'Awaiting transporter assignment' }}
            </div>
            <div style="color:var(--fm-m,#A09888);font-size:12px;margin-top:2px;">
              <i class="mdi mdi-map-marker-outline me-1" style="color:#4FC3F7;"></i>{{ b.pickup_address }}
              <i class="mdi mdi-arrow-right mx-1" style="color:var(--fm-s,#6B6356);"></i>
              <i class="mdi mdi-map-marker-check me-1" style="color:#50C878;"></i>{{ b.delivery_address }}
            </div>
            <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:4px;">
              <span><i class="mdi mdi-calendar me-1"></i>{{ b.scheduled_pickup_date }}<span v-if="b.scheduled_pickup_time"> · {{ b.scheduled_pickup_time }}</span></span>
              <span v-if="b.animal_count" class="ms-2"><i class="mdi mdi-paw me-1"></i>{{ b.animal_count }} animal{{ b.animal_count==1?'':'s' }}</span>
              <span class="ms-2 mt-ref">{{ b.booking_ref }}</span>
            </div>
          </div>
          <div class="text-end" style="flex-shrink:0;">
            <span class="mt-status" :class="'st-'+b.status">{{ b.status.replace(/_/g,' ') }}</span>
            <div v-if="b.final_price || b.quoted_price" style="color:#BFA164;font-weight:600;font-size:13px;margin-top:6px;">
              KES {{ fNum(b.final_price || b.quoted_price) }}
            </div>
            <div style="color:var(--fm-s,#6B6356);font-size:10px;margin-top:2px;">
              Created {{ formatShort(b.created_at) }}
            </div>
          </div>
        </div>
        <!-- Progress bar for active trips -->
        <div v-if="statusGroup(b.status)==='active'" class="mt-progress">
          <div class="mt-progress-fill" :style="{width: progressPct(b.status)+'%'}"></div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .mt-root{background:#F7F5F2!important}
html[data-theme="light"] .mt-topbar{background:rgba(255,255,255,.95)!important;border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .mt-card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .mt-chip{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#555!important}
html[data-theme="light"] .mt-chip.active{background:rgba(191,161,100,.1)!important;border-color:#BFA164!important;color:#BFA164!important}
</style>

<style scoped>
.mt-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh;color:var(--fm-h,#F5F0E8)}
.mt-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.mt-back{color:var(--fm-m,#A09888);font-size:22px;margin-right:4px;text-decoration:none}
.mt-container{padding-top:80px;padding-bottom:60px;max-width:900px}
.mt-chip{padding:6px 14px;border-radius:20px;border:1px solid var(--fm-br,#1E1E1E);background:var(--fm-bg1,#141414);color:var(--fm-m,#A09888);font-size:12px;cursor:pointer;display:inline-flex;align-items:center;gap:6px;transition:all .2s}
.mt-chip:hover{border-color:#BFA164;color:#BFA164}
.mt-chip.active{background:rgba(191,161,100,.1);border-color:#BFA164;color:#BFA164;font-weight:600}
.mt-chip-count{background:var(--fm-bg3,#1E1E1E);padding:1px 6px;border-radius:8px;font-size:10px}
.mt-chip.active .mt-chip-count{background:rgba(191,161,100,.2);color:#BFA164}
.mt-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px;transition:all .15s}
.mt-card:hover{border-color:#BFA164}
.mt-icon{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0}
.ic-pending{background:rgba(255,152,0,.1);color:#FF9800}
.ic-active{background:rgba(191,161,100,.15);color:#BFA164}
.ic-completed{background:rgba(80,200,120,.1);color:#50C878}
.ic-cancelled{background:rgba(255,107,107,.1);color:#FF6B6B}
.mt-status{font-size:10px;font-weight:600;padding:3px 10px;border-radius:8px;text-transform:capitalize}
.st-requested,.st-quoted{background:rgba(255,152,0,.1);color:#FF9800}
.st-confirmed{background:rgba(79,195,247,.1);color:#4FC3F7}
.st-en_route_to_pickup,.st-at_pickup,.st-loading,.st-in_transit,.st-rest_stop,.st-at_delivery,.st-unloading{background:rgba(191,161,100,.15);color:#BFA164}
.st-completed{background:rgba(80,200,120,.1);color:#50C878}
.st-cancelled{background:rgba(255,107,107,.1);color:#FF6B6B}
.mt-ref{background:rgba(191,161,100,.08);color:#BFA164;padding:1px 6px;border-radius:4px;font-family:monospace;font-size:10px}
.mt-progress{height:4px;background:var(--fm-bg3,#1E1E1E);border-radius:2px;margin-top:12px;overflow:hidden}
.mt-progress-fill{height:100%;background:linear-gradient(90deg,#BFA164,#D4B878);transition:width .3s}
</style>

<script>
/* eslint-disable */
import { executeJson, flocker } from "@/api";
export default {
  name: "MyTransportBookings",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,loading:true,
    bookings:[],filter:''
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    filtered(){
      if(!this.filter) return this.bookings;
      var self=this;
      return this.bookings.filter(function(b){return self.statusGroup(b.status)===self.filter});
    }
  },
  mounted(){
    var t=localStorage.getItem('flockr_theme')||'dark';window.__flockrSetTheme(t);
    this.darkMode=t!=='light';this.syncTheme();
    this.themeObserver=new MutationObserver(this.syncTheme);
    this.themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    this.load();
  },
  beforeUnmount(){if(this.themeObserver)this.themeObserver.disconnect()},
  methods:{
    syncTheme(){this.darkMode=document.documentElement.getAttribute('data-theme')!=='light'},
    fNum(n){return Number(n||0).toLocaleString()},
    formatShort(d){if(!d)return'';var dt=new Date(d);return dt.toLocaleDateString('en-KE',{day:'numeric',month:'short'})},
    statusGroup(s){
      if(['requested','quoted'].includes(s)) return 'pending';
      if(['completed'].includes(s)) return 'completed';
      if(['cancelled'].includes(s)) return 'cancelled';
      return 'active'; // confirmed, en_route_to_pickup, at_pickup, loading, in_transit, rest_stop, at_delivery, unloading
    },
    statusIcon(s){
      var g=this.statusGroup(s);
      if(g==='pending') return 'mdi-clock-outline';
      if(g==='completed') return 'mdi-check-all';
      if(g==='cancelled') return 'mdi-close-circle-outline';
      return 'mdi-truck-fast';
    },
    progressPct(status){
      var order=['confirmed','en_route_to_pickup','at_pickup','loading','in_transit','rest_stop','at_delivery','unloading'];
      var i=order.indexOf(status);
      if(i<0) return 0;
      return Math.round(((i+1)/order.length)*100);
    },
    countByGroup(group){
      var self=this;
      return this.bookings.filter(function(b){return self.statusGroup(b.status)===group}).length;
    },
    async load(){
      this.loading=true;
      var userId=sessionStorage.getItem('userId');
      if(!userId){this.$router.push('/login');return}
      try{
        var r=await executeJson({function:'getMyTransportBookings',userId:userId,role:'requester'},flocker);
        if(r.data&&r.data.success&&r.data.data){
          this.bookings=r.data.data.bookings||[];
        }
      }catch(e){console.error(e)}
      this.loading=false;
    }
  }
};
</script>
